import { Row, Select, Spin } from 'antd';
import { SpaceBetween, StyledContainer } from '../../../components/container/styles';
import { TextLarge } from '../../../components/text';
import { ButtonTheme } from '../../../components/buttons';
import { CardTheme } from '../../../components/card';
import React from 'react';
import { Icon } from '../../../resources';
import { Gap } from '../../../components/space';
import { useGetClaimList } from './hooks/useGetClaimList';
import { columns, exportHeaders } from './columns';
import { ContainerButton } from '../../../styles/global-style';
import ButtonExcelEmbedded from '../../../components/report-excel/ButtonExcelEmbedded';
import { InfoRegistration } from './view/InfoRegistration';
import { useTable } from '../../../components/table/hooks';
import { useAntDModalContext } from '../../../components/modal/context/useAntdModalContext';
import { UpdateStatusModal } from './modals/UpdateStatusModal';
import { UpdateTrackingModal } from './modals/UpdateTrackingModal';
import { SendLineMsgModal } from './modals/SendLineMsgModal';
import { UpdateRemarkModal } from './modals/UpdateRemarkModal';
import { ResponsivePageLayout } from '../../../components/page/responsive-layout/ResponsivePageLayout';
import { ExpandedRowContent } from './view/ExpandedRowContent';

import { useStockAvailability } from './hooks/useStockAvailability';
import { dropOverSelectedKeys, getRowStockState, summarizeSelection } from './func/stockHelper';
import { STOCK_ROW_CLASS } from './resource/stockConst';
import { StockSelectionAlert } from './view/StockSelectionAlert';
import { StyledStockTable } from './styles';
import { CLAIM_STATUS, PROCESS_STATUS } from '../../../resources/status';
import { STOCK_ROW_STATE } from './resource/stockConst';
import { filterClaimRows } from './func/filterClaimRows';
const stockFilterOptions = [
  { value: STOCK_ROW_STATE.OK, label: 'สต็อกเพียงพอ' },
  { value: STOCK_ROW_STATE.OUT_OF_STOCK, label: 'สต็อกไม่พอ' },
  { value: STOCK_ROW_STATE.OVER_SELECTED, label: 'เลือกเกินสต็อก' },
  { value: STOCK_ROW_STATE.UNKNOWN, label: 'ไม่มีข้อมูลสต็อก' },
  { value: STOCK_ROW_STATE.STALE, label: 'ข้อมูลสต็อกเก่า' },
  { value: STOCK_ROW_STATE.EXCLUDED, label: 'ไม่คิดสต็อก (จัดส่งแล้ว)' },
];

export const ClaimList = () => {
  const [claimStatusFilter, setClaimStatusFilter] = React.useState();
  const [processStatusFilter, setProcessStatusFilter] = React.useState();
  const [stockStateFilter, setStockStateFilter] = React.useState();
  const { selectedRowKeys, onSelectChange, onClearAllSelected, setSelectedRowKeys } = useTable();
  const {
    transformDataForExcel,
    formSearch,
    isLoadingApproveClaim,
    formSearchObj,
    dataClaimFull,
    loadingClaimFull,
    dataClaimDate,
    loadingClaimDate,
    searchType,
    searchDefaultValues,
    onSearchByField,
    handleSubmitApproveClaim,
    handleSubmitDowmloadShipment,
    isLoadingDownload,
    openProcessStatus,
    onToggleProcessStatus,
    claimData,
    onModalProcessStatus,
    onFetch,
    openTracking,
    onToggleTracking,
    onOpenTracking,
    onToggleLine,
    openLine,
    onOpenLineMessage,
    openRemark,
    onToggleRemark,
    onOpenRemarkMessage,
    gotoClaimAdd,
    onOpenClaimView,
    onOpenClaimEdit,
  } = useGetClaimList({ selectedRowKeys });

  const tableDataSource = searchType === 'search' ? dataClaimFull : dataClaimDate;
  const {
    stockMap,
    meta: stockMeta,
    unavailable: isStockUnavailable,
  } = useStockAvailability(tableDataSource);

  // สต็อกเป็นข้อมูลประกอบอย่างเดียว ไม่ล็อกการทำงาน
  // ผู้ใช้กดเลือก เปลี่ยนสถานะ และอนุมัติได้เสมอ แม้ของไม่พอ
  const { selectedByItem, overItems, overRowKeys } = summarizeSelection({
    dataSource: tableDataSource,
    selectedRowKeys,
    stockMap,
  });

  const filteredDataSource = filterClaimRows({
    rows: tableDataSource,
    claimStatus: claimStatusFilter,
    processStatus: processStatusFilter,
    stockState: stockStateFilter,
    stockMap,
    selectedByItem,
  });

  const onRemoveOverSelected = () => {
    setSelectedRowKeys((prev) => dropOverSelectedKeys(prev, overRowKeys));
  };

  const { openConfirmModal } = useAntDModalContext();

  return (
    <Spin spinning={isLoadingApproveClaim || isLoadingDownload}>
      <StyledContainer>
        <TextLarge text="เคลมสินค้า" />
        <CardTheme>
          <Row gutter={16} flex justify="space-between">
            <Row justify="start">
              <ButtonTheme
                useFor="BILL"
                title="ใบส่งสินค้า"
                onClick={handleSubmitDowmloadShipment}
                disabled={selectedRowKeys.length === 0}
              />
            </Row>
            <Row justify="end">
              <ButtonTheme
                useFor="CONFIRM_CLAIM"
                title="อนุมัติเคลม"
                onClick={() =>
                  openConfirmModal({
                    onOk: () => {
                      handleSubmitApproveClaim();
                    },
                    title: 'คุณต้องการอนุมัติเคลมหรือไม่',
                  })
                }
                disabled={selectedRowKeys.length === 0}
              />
              <ButtonTheme useFor="WARRANTY" title="ยื่นเรื่องเคลม" onClick={gotoClaimAdd} />
            </Row>
          </Row>
          <Gap />
          <StyledStockTable>
            <ResponsivePageLayout
              searchLayout={{
                title: 'ค้นหาการเคลมสินค้า',
                children: (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, width: '100%', margin: '16px 0' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <label htmlFor="claim-status-filter">สถานะ</label>
                      <Select
                        id="claim-status-filter"
                        aria-label="กรองสถานะ"
                        placeholder="สถานะทั้งหมด"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        value={claimStatusFilter}
                        onChange={setClaimStatusFilter}
                        options={CLAIM_STATUS.map(({ key, label }) => ({ value: key, label }))}
                        style={{ width: 220, maxWidth: '100%' }}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <label htmlFor="claim-process-status-filter">สถานะภายใน</label>
                      <Select
                        id="claim-process-status-filter"
                        aria-label="กรองสถานะภายใน"
                        placeholder="สถานะภายในทั้งหมด"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        value={processStatusFilter}
                        onChange={setProcessStatusFilter}
                        options={PROCESS_STATUS.map(({ key, label }) => ({ value: key, label }))}
                        style={{ width: 240, maxWidth: '100%' }}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <label htmlFor="claim-stock-filter">สต็อก</label>
                      <Select
                        id="claim-stock-filter"
                        aria-label="กรองสต็อก"
                        placeholder="สต็อกทั้งหมด"
                        allowClear
                        value={stockStateFilter}
                        onChange={setStockStateFilter}
                        options={stockFilterOptions}
                        style={{ width: 240, maxWidth: '100%' }}
                      />
                    </div>
                  </div>
                ),

                icon: <Icon.Todo />,
                formSearch,
                useFormParam: formSearchObj,
                onSearch: formSearchObj.handleSubmit(onSearchByField),
                onClearCustom: () => {
                  formSearchObj.reset(searchDefaultValues);
                  setClaimStatusFilter(undefined);
                  setProcessStatusFilter(undefined);
                  setStockStateFilter(undefined);
                  onClearAllSelected([]);
                },
              }}
              content={<InfoRegistration />}
              tableLayout={{
                columns: columns({
                  onModalProcessStatus,
                  stockMap,
                  selectedByItem,
                  onOpenTracking,
                  onOpenLineMessage,
                  onOpenRemarkMessage,
                  onOpenClaimView,
                  onOpenClaimEdit,
                }),
                loading: loadingClaimFull || loadingClaimDate,
                dataSource: filteredDataSource,
                rowClassName: (record) => {
                  const { state } = getRowStockState({ record, stockMap, selectedByItem });
                  return STOCK_ROW_CLASS[state] ?? '';
                },
                hasPagination: true,
                rowKey: 'claimId',
                rowSelection: {
                  selectedRowKeys,
                  onChange: onSelectChange,
                },
                expandable: {
                  expandedRowRender: (record) => <ExpandedRowContent record={record} />,
                },
                extraContent: (
                  <>
                    <StockSelectionAlert
                      unavailable={isStockUnavailable}
                      overItems={overItems}
                      selectedCount={selectedRowKeys.length}
                      staleMinutes={stockMeta.staleMinutes}
                      onRemoveOverSelected={onRemoveOverSelected}
                    />
                    <SpaceBetween>
                      <ContainerButton right>
                        <ButtonExcelEmbedded
                          title="Export"
                          filename="รายงานการยื่นเรื่องเคลม"
                          header={exportHeaders}
                          data={transformDataForExcel(
                            filteredDataSource,
                          )}
                        />
                      </ContainerButton>
                    </SpaceBetween>
                  </>
                ),
              }}
            />
          </StyledStockTable>
        </CardTheme>
        {openProcessStatus && (
          <UpdateStatusModal
            open={openProcessStatus}
            onToggle={onToggleProcessStatus}
            claimData={claimData}
            onFetch={onFetch}
          />
        )}
        {openTracking && (
          <UpdateTrackingModal
            open={openTracking}
            onToggle={onToggleTracking}
            claimData={claimData}
            onFetch={onFetch}
          />
        )}
        {openLine && (
          <SendLineMsgModal
            open={openLine}
            onToggle={onToggleLine}
            claimData={claimData}
            onFetch={onFetch}
          />
        )}
        {openRemark && (
          <UpdateRemarkModal
            open={openRemark}
            onToggle={onToggleRemark}
            claimData={claimData}
            onFetch={onFetch}
          />
        )}
      </StyledContainer>
    </Spin>
  );
};
